

































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import PeopleManagementService from '@/domain/people-management/service/people-management.service';
import Role from '@/domain/people-management/entity/role.entity';
import KeyValueParameter from '@/shared/parameters/key-value-parameter.component.vue';
import Rules from '@/shared/rules/rules';

@Component({
  components: {
    KeyValueParameter,
  },
})

export default class RoleComponent extends Vue {
  @Prop({ type: Object }) data!: any;

  @Prop({ type: Boolean, default: false }) disabled!: boolean;

  @Prop({ type: Boolean, default: false }) readonly!: boolean;

  roleList: Role[] = [];

  validationsRules: Rules = new Rules();

  created() {
    this.getRoles();
  }

  getRoles() {
    PeopleManagementService.getAllRoles().then((response) => {
      this.roleList = Role.ofList(response);
    })
  }
}
